import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL
const ADMIN_TOKEN_KEY = 'admin_auth_token'

export interface AdminUser {
  _id: string
  username: string
  email: string
  role: string
  is_super_admin?: boolean
}

export interface AdminLoginResponse {
  success: boolean
  token: string
  admin: AdminUser
}

// Get stored admin token
export function getAdminToken(): string | null {
  return localStorage.getItem(ADMIN_TOKEN_KEY)
}

// Save admin token
export function saveAdminToken(token: string): void {
  localStorage.setItem(ADMIN_TOKEN_KEY, token)
}

// Clear admin token
export function clearAdminToken(): void {
  localStorage.removeItem(ADMIN_TOKEN_KEY)
}

// Get auth headers
function getAuthHeaders(): Record<string, string> {
  const token = getAdminToken()
  return token ? { Authorization: `Bearer ${token}` } : {}
}

// Admin login - returns JWT token
export function adminLogin(username: string, password: string, turnstileToken?: string): Promise<{ data: AdminLoginResponse }> {
  return axios.post(`${API_URL}/admin/api-login`, { username, password, turnstileToken }, { withCredentials: true })
}

// Check if admin is logged in
export function checkAdminAuth(): Promise<{ data: { loggedIn: boolean; admin?: AdminUser } }> {
  return axios.get(`${API_URL}/admin/check-auth`, {
    headers: getAuthHeaders(),
    withCredentials: true
  })
}

// Admin logout
export function adminLogout(): Promise<{ data: { success: boolean } }> {
  clearAdminToken()
  return axios.post(`${API_URL}/admin/api-logout`, {}, { withCredentials: true })
}
